<template>
  <div>
    <el-row v-if="!canEdit">
      <template v-for="(countColumn, index) in countColumns">
        <el-col v-if="countColumn.title" :key="index" :span="countColumn.span">
          <div class="grid-content bg-purple-dark">
            {{ countColumn.title }}
          </div>
        </el-col>
        <el-col v-else :key="index" :span="countColumn.span">
          <div class="grid-content bg-purple-dark">
            <el-input :value="baseData[countColumn.prop]" :disabled="true"> </el-input>
          </div>
        </el-col>
      </template>
      <!-- <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{this.$t("futuresStrategy.strategicContract.column.purchaseCount")}}
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="purchaseCount"  :disabled="true"> </el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{this.$t("futuresStrategy.strategicContract.column.purchaseAmount")}}
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="purchaseAmount"  :disabled="true"> </el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{this.$t("futuresStrategy.strategicContract.column.salesCount")}}
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="salesCount"  :disabled="true"> </el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{this.$t("futuresStrategy.strategicContract.column.salesAmount")}}
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="salesAmount"  :disabled="true"> </el-input>
          </div>
        </el-col> -->
    </el-row>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent(-1)"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('futuresStrategy.button.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('futuresStrategy.button.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      :row-id="propCode || 'id'"
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-config="canEdit ? { trigger: 'click', mode: 'row' } : ''"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :max-height="$store.state.app.tableHeight"
      highlight-current-row
      highlight-hover-row
      column-min-width="120"
    >
    </vxe-grid>
    <contract-dialog ref="dialog" @handleAdd="handleAdd" />
    <!-- 新增的时候选择关联合同入库明细dialog -->
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import API from '@/api/futuresStrategy/index';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  import ContractDialog from './contractDialog';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    name: 'contractDetailsInfo',
    props: ['canEdit'],
    components: {
      // SearchTable,
      // InputNumber,
      // inputNumberAd,
      ContractDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        contractList: function (state) {
          let salesList = state.dict.dictListMap.sales_contract_detail_category;
          let purchaseList = state.dict.dictListMap.purchase_contract_detail_category;
          return salesList.concat(purchaseList);
        },
      }),
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 序号
            type: 'seq',
            width: 60,
            title: this.$t('table.index'),
          },
          {
            // 合同编号
            field: 'contractNo',
            title: this.$t('futuresStrategy.strategicContract.column.contractNo'),
          },
          {
            // 合同行
            field: 'contractDetailNo',
            title: this.$t('futuresStrategy.strategicContract.column.contractDetailNo'),
          },
          {
            // 商品描述
            field: 'productDesc',
            title: this.$t('futuresStrategy.strategicContract.column.productDesc'),
          },
          {
            // 商品数量
            field: 'productQuantity',
            title: this.$t('futuresStrategy.strategicContract.column.productQuantity'),
          },
          {
            // 合同日期
            field: 'contractDate',
            title: this.$t('futuresStrategy.strategicContract.column.contractDate'),
          },
          {
            // 合同类型
            field: 'contractDetailCategory',
            title: this.$t('futuresStrategy.strategicContract.column.contractDetailCategory'),
            editRender: {
              name: 'ElSelect',
              options: this.contractList,
              props: {
                clearable: true,
              },
            },
          },
          {
            // 合同执行情况
            field: 'contractStatusName',
            title: this.$t('futuresStrategy.strategicContract.column.contractStatus'),
            /* editRender: { 
            name: "ElSelect",
            options: this.$baseRequest.getDictListMapByType('contract_request_status'),
            props: {
              clearable:true,
            },
          } */
          },
        ];
      },
      countColumns() {
        return [
          {
            //采购合同数量合计
            title: this.$t('futuresStrategy.strategicContract.column.purchaseCount'),
            span: 3,
          },
          {
            //
            prop: 'puescheProductCount',
            span: 2,
          },
          {
            //采购合同金额
            title: this.$t('futuresStrategy.strategicContract.column.purchaseAmount'),
            span: 3,
          },
          {
            //
            prop: 'purchaseAmount',
            span: 2,
          },
          {
            //销售合同数量合计
            title: this.$t('futuresStrategy.strategicContract.column.salesCount'),
            span: 3,
          },
          {
            prop: 'salesProductCount',
            span: 2,
          },
          {
            //销售合同金额
            title: this.$t('futuresStrategy.strategicContract.column.salesAmount'),
            span: 3,
          },
          {
            prop: 'salesAmount',
            span: 2,
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
        delIds: [],
        baseData: {
          puescheProductCount: 0,
          purchaseAmount: 0,
          salesProductCount: 0,
          salesAmount: 0,
        },
        propCode: 'contractNo',
      };
    },
    methods: {
      insertEvent() {
        // 表格新增一行
        this.$emit('openDialog', 'detailInfo', this.$refs.table.getTableData().fullData);
      },
      handleDelete() {
        // 表格删除
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.delIds.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancelled') });
          });
      },

      updateData() {
        this.$refs.table.updateData();
      },
      handleAdd(data) {
        this.tableData = [...data, ...this.$refs.table.getTableData().fullData];
        this.updateData();
      },

      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        if (tableData.length == 0) {
          return {
            delIds: this.delIds,
            list: [],
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              let param = {
                delIds: this.delIds,
                list: tableData,
              };
              resolve(param);
            });
          });
        }
      },
    },
  };
</script>
<style scoped>
  .el-row {
    margin-bottom: 10px;
    font-size: 12px;
    text-align: right;
    vertical-align: middle;
    color: #606266;
  }
  .el-col {
    border-radius: 4px;
    line-height: 32px;
  }
  .grid-content {
    padding: 0 12px 0 0 !important;
  }
</style>
